

























































import { Vue, Prop, Component, Watch } from "vue-property-decorator";
import { WebsiteCommonService } from "@/zh-website/src/service/data-service/website";
@Component({
  components: {}
})
export default class Website extends Vue {
  enterpriseList = []; // 行业人才发展
  productList = []; // 产业技术培训
  digitalList = []; // 数字化领导力

  collegesList = []; // 产品与解决方案
  caseDetailList = []; // 院校案例
  get list() {
    return [
      {
        h4: {
          text: "政企用户"
        },
        list: [
          {
            h5: {
              text: "行业人才发展",
              target: "_blank",
              url: "/enterprise/page"
            },
            list: this.enterpriseList
          },
          {
            h5: {
              text: "产业技术培训",
              target: "_blank",
              url: "/enterprise/product/page"
            },
            list: this.productList
          },
          {
            h5: {
              text: "数字化领导力",
              target: "_blank",
              url: "/enterprise/digital/page"
            },
            list: this.digitalList
          },
          {
            h5: {
              text: "成功案例",
              target: "_blank",
              url: "/enterprise/all-success-case"
            },
            list: []
          },
          {
            h5: {
              text: "华为认证",
              target: "_blank",
              url: "/enterprise/authent/1"
            },
            list: []
          }
        ]
      },
      {
        h4: {
          text: "高校用户"
        },
        list: [
          {
            h5: {
              text: "产品与解决方案",
              target: "_blank",
              url: "/colleges/page"
            },
            list: this.collegesList
          },
          {
            h5: {
              text: "院校案例",
              target: "_blank",
              url: "/colleges/caseDetail/1"
            },
            list: this.caseDetailList
          },
          {
            h5: {
              text: "教育与合作",
              target: "_blank",
              url: "/colleges/teach/1"
            },
            list: []
          },
          {
            h5: {
              text: "华为认证",
              target: "_blank",
              url: "/colleges/authent/1"
            },
            list: []
          }
        ]
      },
      {
        h4: {
          text: "合作伙伴"
        },
        list: [
          {
            h5: {
              text: "行业专家合作",
              target: "_blank",
              url: "/partner/industry/page/0"
            },
            list: [
              {
                text: "专家权益",
                target: "_blank",
                url: "/partner/industry/page/2"
              },
              {
                text: "常见问题",
                target: "_blank",
                url: "/partner/industry/page/3"
              },
              {
                text: "申请加入",
                target: "_blank",
                url: "/partner/industry/page/4"
              }
            ]
          },
          {
            h5: {
              text: "渠道合作",
              target: "_blank",
              url: "/partner/channel/1"
            },
            list: [
              {
                text: "成为渠道伙伴",
                target: "_blank",
                url: "/partner/channel/1"
              },
              {
                text: "了解政策权益",
                target: "_blank",
                url: "/partner/channel/2"
              },
              {
                text: "查询渠道伙伴",
                target: "_blank",
                url: "/partner/channel/3"
              }
            ]
          },
          {
            h5: {
              text: "供应商专区",
              target: "_blank",
              url: "/partner/supplier"
            },
            list: []
          }
        ]
      },
      {
        h4: {
          text: "人才招聘"
        },
        list: [
          {
            h5: {
              text: "社会招聘",
              target: "_blank",
              url: "/home/recruit/social"
            },
            list: []
          },
          {
            h5: {
              text: "校园招聘",
              target: "_blank",
              url: "/home/recruit/campus"
            },
            list: []
          }
        ]
      },
      {
        h4: {
          text: "关于浙江华为"
        },
        list: [
          {
            h5: {
              text: "公司介绍",
              target: "_blank",
              url: "/home/aboutus"
            },
            list: []
          },
          {
            h5: {
              text: "新闻中心",
              target: "_blank",
              url: "/home/news/page"
            },
            list: []
          }
        ]
      }
    ];
  }

  mounted() {
    this.getList();
  }
  dealData(list, baseRouter, noId = false) {
    const _list: any = [];
    list.map((item, index) => {
      const { name: text, id } = item;
      let url = "";
      if (!noId) {
        url = `${baseRouter}${id}`;
      } else {
        url = `${baseRouter}${list.length - index}`;
      }
      const obj = {
        text,
        target: "_blank",
        url
      };
      _list.push(obj);
    });
    return _list;
  }
  getList() {
    WebsiteCommonService.getNavigationList({ typeList: 1 }).then((res: any) => {
      res.data.navigation.map(item => {
        const childList = item.childNavigation;
        switch (item.name) {
          case "行业人才发展":
            this.enterpriseList = this.dealData(
              childList,
              "/enterprise/industry/classify/"
            );
            break;
          case "产品技术培训":
            this.productList = this.dealData(
              childList,
              "/enterprise/product/classify/"
            );
            break;
          case "数字化领导力":
            this.digitalList = this.dealData(
              childList,
              "/enterprise/digital/classify/"
            );
            break;
        }
      });
    });
    WebsiteCommonService.getNavigationList({
      typeList: 2
    }).then((res: any) => {
      res.data.navigation.map(item => {
        const childList = item.childNavigation;
        switch (item.name) {
          case "产品与解决方案":
            this.collegesList = this.dealData(
              childList,
              "/colleges/solve/profession/"
            );
            break;
          case "院校案例":
            this.caseDetailList = this.dealData(
              childList,
              "/colleges/caseDetail/",
            );
            break;
        }
      });
    });
  }
}
